<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('cashCollectionByCashier.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('cashCollectionByCashier.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('cashCollectionByCashier.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashCollectionByCashier.branchName')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashCollectionByCashier.cashier')
                      }}</label>
                      <a-select
                        style="width:100%"
                        mode="multiple"
                        v-model="model.cashier_id"
                        :options="cashiers"
                      ></a-select>
                      <div class="validate" v-if="errors.has('cashier_id')">
                        {{ errors.first('cashier_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashCollectionByCashier.date')
                      }}</label>
                      <a-range-picker
                        style="width:100%"
                        v-model="model.date_range"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                      />
                      <div class="validate" v-if="errors.has('date_range')">
                        {{ errors.first('date_range') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('cashCollectionByCashier.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'cashCollectionByCashier',
  data() {
    return {
      loading: false,
      waiting: false,
      src: '',
      errors: new Errors(),
      branches: [],
      cashiers: [],
      model: {
        cashier_id: undefined,
        branch_id: null,
        date_range: [moment(), moment()]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportPayment', ['getCashier', 'bycashier', 'getBranch']),
    async fetchData() {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
        this.model.branch_id = this.$store.state.authUser.default_branch_id
      })
      await this.getCashier()
        .then(response => {
          this.cashiers = response.data.map(el => ({
            value: el.cashier_id,
            label: el.cashier
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.bycashier(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
